import { BundleProductModel } from "@/api/mappers/productBundles.mapper";

import { ProductBundlePriceComponent } from "./productBundlePrice.component";

type ProductBundlePriceProps = {
    bundleProducts: Array<BundleProductModel>;
    className?: string;
};

const ProductBundlePrice = ({
    bundleProducts,
    className
}: ProductBundlePriceProps) => {
    const salesPrice = bundleProducts.reduce(
        (sum, { product, quantity }) =>
            sum + (product.price?.currentPrice ?? 0) * quantity,
        0
    );

    const showStrippedPrice = !!bundleProducts.some(
        ({ product }) => product.price?.strikethroughPrice
    );

    const strikethroughPrice = showStrippedPrice
        ? bundleProducts.reduce(
              (sum, { product, quantity }) =>
                  sum +
                  (product.price?.strikethroughPrice ??
                      product.price?.currentPrice ??
                      0) *
                      quantity,
              0
          )
        : undefined;

    return (
        <ProductBundlePriceComponent
            className={className}
            strikethroughPrice={strikethroughPrice}
            salesPrice={salesPrice}
        />
    );
};

export { ProductBundlePrice };
